<template>
    <div>
        <template class="pa-0 ma-0" v-if="user_type === 'Employee'">
            <div>
                <!-- 🎂 Animated Birthday Dialog -->
                <v-dialog v-model="showBirthdayDialog" max-width="600" transition="scale-transition" persistent>
                    <v-card class="animated-dialog pa-4">
                        <!-- 🎉 Title -->
                        <v-card-title
                            class="headline font-weight-bold dialog-text-animate justify-center text-h5 text-center">
                            🎉 Happy Birthday, {{ user.name }}! 🎂
                        </v-card-title>
                        <!-- ✨ Optional birthday image -->
                        <v-img :src="require('@/assets/gift.gif')" contain max-height="120"
                            class="my-2 mx-auto"></v-img>

                        <!-- 💬 Message -->
                        <v-card-text class="dialog-text-animate text-center text-subtitle-1">
                            <p>Wishing you a fantastic day filled with joy, success, and smiles! ✨</p>
                            <p class="font-italic">Enjoy every moment — it’s your day! 🎊</p>
                        </v-card-text>

                        <!-- ✅ Button -->
                        <v-card-actions class="justify-center">
                            <v-btn color="deep-purple accent-4" dark @click="closeDialog">
                                🎁 Thanks!
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
            <v-row>
                <v-col cols="12" sm="12" md="12" class="pa-4">
                    <!-- Search Combobox -->
                    <v-combobox v-if="isDrawer" dense clearable :items="search_links" item-text="name"
                        background-color="white" class="pt-2" v-model="goto_link" label="Search links" rounded outlined
                        return-object @change="gotoLink" aria-label="Search links">
                        <template v-slot:append>
                            <v-icon class="cursor-pointer" @click="gotoLink" aria-label="Search">mdi-magnify</v-icon>
                        </template>
                    </v-combobox>
                    <!-- Calendar, Module, Library -->
                    <v-sheet class="pa-2 mr-1 mb-2 asym-card" color="brandLight" style="border-radius: 10px;">
                        <v-card flat class="ma-1 pa-2" shaped>
                            <v-container fluid class="pa-0">
                                <v-row dense class="d-flex flex-wrap">
                                    <!-- MY CALENDAR -->
                                    <v-col cols="12" sm="12" md="12" class="pa-0">
                                        <v-btn text color="#58355e" class="justify-start" @click="my_calender">
                                            <span class="mr-2">📅</span>
                                            <span class="text-wrap font-weight-bold">MY CALENDAR</span>
                                        </v-btn>
                                    </v-col>

                                    <!-- MODULE MANAGEMENT -->
                                    <v-col cols="12" sm="12" md="12" class="pa-0">
                                        <v-btn text color="#58355e" class="justify-start" @click="module_management">
                                            <span class="mr-2">📚</span>
                                            <span class="text-wrap font-weight-bold">MODULE MANAGEMENT</span>
                                        </v-btn>
                                    </v-col>

                                    <!-- LIBRARY -->
                                    <v-col cols="12" sm="12" md="12" class="py-0"
                                        v-if="lib_url && erp_lib_flag === 'YES' && flag">
                                        <form :action="lib_url" name="library" target="_blank" method="post"
                                            class="ma-0 pa-0">
                                            <input name="prn" type="hidden" :value="prn" />
                                            <input name="tenant" type="hidden" :value="tenant" />
                                            <input name="random_key" type="hidden" :value="random_key" />
                                            <input name="uid" type="hidden" :value="uid" />
                                            <input name="hash_key" type="hidden" :value="hash_key" />
                                            <input name="erp_url" type="hidden" :value="erp_url" />
                                            <input name="device_name" type="hidden" :value="device_name" />
                                            <input name="org_code" type="hidden" :value="org_code" />
                                            <v-btn text color="#58355e" type="submit" class="justify-start">
                                                <span class="mr-2">🏛️</span>
                                                <span class="font-weight-bold">LIBRARY</span>
                                            </v-btn>
                                        </form>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>

                    </v-sheet>
                    <!-- Quick Links Component -->
                    <v-sheet class="pa-2 mr-1 mb-2 asym-card" color="brandLight" style="border-radius: 10px;">
                        <v-card flat shaped class="pa-4 mt-1" color="white">
                            <QuickLinkComponents />
                        </v-card>
                    </v-sheet>
                    <!-- Sessions Card -->
                    <v-card flat class="pa-4 mt-3" style="border-radius: 10px;" color="brandLight">
                        <v-expansion-panels flat>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>
                                        <span style="font-size: 20px; margin-right: 12px;">📒</span>
                                        <span class="text-lg font-semibold text-gray-800">Sessions</span>
                                    </b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="pt-2">
                                    <div v-if="tt_list.length">
                                        <v-row v-for="(data, index) in tt_list" :key="index">
                                            <v-col cols="12">
                                                <v-card flat class="pa-2 mb-2" style="width: 100%;">
                                                    <div v-if="data.tt_course" class="d-flex align-center mb-1">
                                                        <v-icon small color="green"
                                                            class="mr-2">mdi-book-open-variant</v-icon>
                                                        <span>{{ data.tt_course }}</span>
                                                    </div>
                                                    <div v-if="data.tt_room" class="d-flex align-center mb-1">
                                                        <v-icon small color="blue" class="mr-2">205</v-icon>
                                                        <span>{{ data.tt_room }}</span>
                                                    </div>
                                                    <div v-if="data.tt_event" class="d-flex align-center mb-1">
                                                        <v-icon small color="green" class="mr-2">12</v-icon>
                                                        <span>{{ data.tt_event }}</span>
                                                    </div>
                                                    <div v-if="data.tt_slot" class="d-flex align-center mb-1">
                                                        <v-icon small color="#9808EB" class="mr-2">10</v-icon>
                                                        <span>{{ data.tt_slot }}</span>
                                                    </div>
                                                    <div v-if="data.tt_div" class="d-flex align-center mb-1">
                                                        <v-icon small color="#9808EB" class="mr-2">208</v-icon>
                                                        <span>{{ data.tt_std }}-{{ data.tt_div }}</span>
                                                    </div>
                                                    <a v-if="data.tt_web_link" :href="data.tt_web_link" target="_blank">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon small color="blue" v-bind="attrs" v-on="on"
                                                                    aria-label="Webinar Link">mdi-link</v-icon>
                                                            </template>
                                                            <span>Webinar Link</span>
                                                        </v-tooltip>
                                                    </a>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-else>
                                        <strong>No Sessions Today</strong>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                    <!-- Events Card -->
                    <v-card flat class="pa-4 mt-3" style="border-radius: 10px;" color="brandLight" ripple hover>
                        <v-expansion-panels flat>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>
                                        <span style="font-size: 20px; margin-right: 12px;">🗓️</span>
                                        <span class="text-lg font-semibold text-gray-800">Events <small>(7
                                                days)</small></span>
                                    </b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="pt-2">
                                    <div v-if="leave_list.length">
                                        <strong>Leaves Applied</strong>
                                        <v-row v-for="(i, index) in leave_list" :key="index">
                                            <v-col cols="12">
                                                {{ index + 1 }}. {{ i.leave_type }} - {{ i.leaveapprovalstatus }}
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-if="holiday_list.length" class="mt-2">
                                        <strong>Holidays</strong>
                                        <v-row v-for="(i, index) in holiday_list" :key="index">
                                            <v-col cols="12">
                                                {{ index + 1 }}. {{ i.holidaydate }} - {{ i.holiday }}
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-if="event_list.length" class="mt-2">
                                        <strong>Events</strong>
                                        <v-row v-for="(i, index) in event_list" :key="index">
                                            <v-col cols="12">
                                                {{ index + 1 }}. {{ i.event }} - {{ i.event_date_time }}
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                    <!-- Birthday Card -->
                    <v-card flat class="pa-4 mt-3" style="border-radius: 10px;" color="brandLight" ripple hover>
                        <v-expansion-panels focusable flat tile>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>
                                        <span style="font-size: 20px; margin-right: 12px;">🎂</span>
                                        <span class="text-lg font-semibold text-gray-800">Birthdays 🎉</span>
                                    </b>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content>
                                    <!-- Instructor Birthdays -->
                                    <div v-if="bday_list.length">
                                        <v-subheader class="font-weight-bold text--primary">🧑‍🏫
                                            Instructors</v-subheader>
                                        <v-row dense>
                                            <v-col v-for="(i, index) in bday_list" :key="'inst-' + index" cols="12"
                                                class="d-flex align-center mb-3">
                                                <v-avatar size="45" class="mr-3 elevation-2">
                                                    <v-img v-if="i.photo_path" :src="awspath + i.photo_path" />
                                                    <v-icon v-else x-large color="primary">mdi-account-circle</v-icon>
                                                </v-avatar>
                                                <span style="font-size: 15px; font-weight: 500;">🎈 {{ i.inst }}</span>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <!-- Student Birthdays -->
                                    <div v-if="bday_list_student.length" class="mt-4">
                                        <v-subheader class="font-weight-bold text--primary">🎓 Students</v-subheader>
                                        <v-row dense>
                                            <v-col v-for="(s, sIndex) in bday_list_student" :key="'stud-' + sIndex"
                                                cols="12" class="d-flex align-center mb-3">
                                                <v-avatar size="45" class="mr-3 elevation-2">
                                                    <v-img v-if="s.photo_path" :src="awspath + s.photo_path" />
                                                    <v-icon v-else x-large color="primary">mdi-account-circle</v-icon>
                                                </v-avatar>
                                                <div>
                                                    <div style="display: flex; align-items: flex-start;font-size: 15px; font-weight: 500;"><span style="width: 22px;">🎂</span><span>{{ s.student }}</span></div>
                                                    <div style="font-size: 13px; color: #666;">
                                                        🏫  <span class="ml-1">{{ s.standard }} - {{ s.division }}</span>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                    <!-- Training Details Card -->
                    <v-card v-if="tenant === 'wws'" style="border-radius: 10px;" flat class="pa-4 mt-3" color="brandLight">
                        <v-expansion-panels flat>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <b>
                                        <span style="font-size: 20px; margin-right: 12px;">🧑‍🏫</span>
                                        <span class="text-lg font-semibold text-gray-800">Training Details <small
                                                v-if="training_ay">({{
                                                    training_ay }})</small></span>
                                    </b>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="pt-2">
                                    <v-row v-if="training_details.length">
                                        <v-col cols="12">
                                            <label>Training Required: <b>{{ training_details[0].required_training_hours
                                            }}
                                                    (Min)</b></label><br />
                                            <label>Training Completed: <b>{{
                                                training_details[0].training_hours_completed }}</b></label>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                </v-col>
            </v-row>
        </template>

        <!-- EasyCheck Form -->
        <v-row v-if="easycheck_url && erp_easycheck_flag === 'YES' && flag" justify="center" class="mt-4">
            <v-col cols="12" sm="6" md="4">
                <form :action="easycheck_url" name="easycheck" method="POST">
                    <input name="uid" type="hidden" :value="uid" />
                    <input name="hash_key" type="hidden" :value="hash_key" />
                    <input name="erp_url" type="hidden" :value="erp_url" />
                    <input name="device_name" type="hidden" :value="device_name" />
                    <v-btn block large rounded type="submit" color="green" class="white--text py-4"
                        aria-label="Proceed to EasyCheck">
                        <strong>Proceed To EasyCheck</strong>
                    </v-btn>
                </form>
            </v-col>
        </v-row>

        <!-- Calendar Dialog -->
        <v-dialog v-model="dialog_inst_cal" width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-btn icon dark @click="dialog_inst_cal = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>My Calendar</v-toolbar-title>
                        </v-toolbar>  
                        <!-- {{ events }} -->
                          <instructor_calendar v-if="events.length > 0" :events="events"></instructor_calendar>      
                        <center class="red--text font-weight-bold mt-2" v-else>No data found !!!</center>                      
                                          
                    </v-card>
                    <!-- calendar content end -->
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";

export default {
    components: {
        QuickLinkComponents: () => import("./QuickLinkComponents.vue"),
        parentProfileCard: () => import("./ParentProfileCard.vue"),
        parentUpcomingEvents: () => import("./ParentUpcomingEvents.vue"),
        instructor_calendar: () => import("../Academics/AcademicPlanner/InstructorCalendar"),
    },
    data() {
        return {
            user: {
                name: "",
                isBirthdayToday: false
            },
             musicPlayer: null, // store reference to audio
            showBirthdayDialog: false,
            quick_links: [],
            awspath: null,
            bday_list: [],
            bday_list_student: [],
            tt_list: [],
            holiday_list: [],
            event_list: [],
            leave_list: [],
            training_details: [],
            training_ay: "",
            tenant: "",
            dialog_inst_cal: false,
            events: [],
            search_links: [],
            goto_link: null,
            easycheck_url: "http://localhost:8080",
            lib_url: "http://localhost:8080",
            uid: "",
            prn: "",
            random_key: "",
            hash_key: "",
            flag: false,
            erp_url: "",
            device_name: "",
            erp_easycheck_flag: null,
            erp_lib_flag: null,
            org_code: "",
            user_type: null,
            isDrawer: sessionStorage.getItem("isDrawer") === null ? true : sessionStorage.getItem("isDrawer") === "true",
            isLoading: false,
        };
    },
    computed: {
        filteredItems() {
            if (!this.moduleSearch) return this.items;
            return this.items.filter((item) => item.name && item.name.toLowerCase().includes(this.moduleSearch.toLowerCase()));
        },
    },
    methods: {
        module_management() {
            sessionStorage.setItem("para_role_type","Modules")
            this.$router.push("/role-dashboard/modules");
        },
        my_calender() {
            this.dialog_inst_cal = true;
        },
        gotoLink() {
            if (this.goto_link && this.search_links.includes(this.goto_link)) {
                sessionStorage.removeItem("emp_role");
                sessionStorage.removeItem("para_role");
                sessionStorage.removeItem("sblinks");
                sessionStorage.setItem("search_para_role", this.goto_link.para_role);
                sessionStorage.setItem("search_para_role_type", this.goto_link.search_para_role_type);
                sessionStorage.setItem("search_link", this.goto_link.name);
                this.$router.push({ name: this.goto_link.link });
            }
        },
        todayBirthday() {
            axios
                .get("/communication/todayBirthday")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.user.isBirthdayToday = res.data.isBirthdayToday;
                        this.user.name = res.data.birthday_name; // ❗ make sure backend sends `birthday_name`

                        if (this.user.isBirthdayToday) {

                            const isShown = sessionStorage.getItem("birthdayDialogShown");
                            if (!isShown) {
                                // 🎶 Play music
                                this.playBirthdayMusic();
                                this.showBirthdayDialog = true;
                                this.launchConfetti();
                                this.launchEmojiConfetti();
                                sessionStorage.setItem("birthdayDialogShown", true);
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        playBirthdayMusic() {
        this.stopBirthdayMusic(); // stop any previous music
        this.musicPlayer = new Audio(require('@/assets/happy-birthday-155461.mp3'));
        this.musicPlayer.loop = false; // set true if you want it to loop
        this.musicPlayer.play().catch(err => {
            console.warn("Music playback blocked until user interacts with the page", err);
        });
    },
    stopBirthdayMusic() {
        if (this.musicPlayer) {
            this.musicPlayer.pause();
            this.musicPlayer.currentTime = 0;
            this.musicPlayer.src = ""; // unload audio completely
            this.musicPlayer = null;
        }
    },
        closeDialog() {
        this.showBirthdayDialog = false;
        this.stopBirthdayMusic(); // ⏹ fully stop
    },
        launchConfetti() {
            const duration = 3 * 1000;
            const animationEnd = Date.now() + duration;
            const defaults = {
                startVelocity: 45,
                spread: 360,
                ticks: 80,
                gravity: 0.9,
                scalar: 1.2,
                zIndex: 9999,
                shapes: ['circle', 'square'],
                colors: ['#bb0000', '#ffffff', '#00bb00', '#0000bb', '#ffaa00']
            };

            const interval = setInterval(() => {
                const timeLeft = animationEnd - Date.now();

                if (timeLeft <= 0) {
                    clearInterval(interval);
                    return;
                }

                const particleCount = 80 * (timeLeft / duration);

                confetti(
                    Object.assign({}, defaults, {
                        particleCount: Math.floor(particleCount),
                        origin: {
                            x: Math.random(),
                            y: Math.random() - 0.2
                        }
                    })
                );
            }, 200);
        },
        launchEmojiConfetti() {
            const emojis = ['🎉', '✨', '🎊', '🎈', '✨'];
            const duration = 3000;
            const end = Date.now() + duration;

            const interval = setInterval(() => {
                if (Date.now() > end) {
                    clearInterval(interval);
                    return;
                }

                // Create a floating emoji element
                const emoji = document.createElement('div');
                emoji.innerText = emojis[Math.floor(Math.random() * emojis.length)];
                emoji.style.position = 'fixed';
                emoji.style.zIndex = 9999;
                emoji.style.fontSize = `${Math.random() * 30 + 30}px`;
                emoji.style.left = `${Math.random() * 100}%`;
                emoji.style.top = `${Math.random() * 100}%`;
                emoji.style.pointerEvents = 'none';
                emoji.style.opacity = '1';
                emoji.style.transition = 'transform 3s ease-out, opacity 3s ease-out';
                emoji.style.transform = `translateY(-${Math.random() * 200 + 100}px) rotate(${Math.random() * 360}deg)`;

                document.body.appendChild(emoji);

                // Animate and remove
                requestAnimationFrame(() => {
                    emoji.style.transform += ' translateY(-100px)';
                    emoji.style.opacity = '0';
                });

                setTimeout(() => {
                    emoji.remove();
                }, 3000);
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg || "Can't load profile data";
        },
        onerror(error) {
            let msg = error.response ? "Something went wrong." : error.request ? "Please try again." : "Unexpected error.";
            this.showSnackbar("error", msg);
        },
        async fetchData() {
            this.isLoading = true;
            try {
                const [eventsRes, sessionRes, birthdayRes, trainingRes, sidebarRes] = await Promise.all([
                    axios.post("/communication/getInstructorEventsNew"),
                    axios.post("/communication/getInstructorSession"),
                    axios.post("/communication/getInstructorBirthday"),
                    axios.post("/communication/getInstructorTraining"),
                    axios.get("/home/dashboardsidebar"),
                ]);

                // Instructor Events
                if (eventsRes.data.flag === "YES") {
                    this.holiday_list = eventsRes.data.holiday_list;
                    this.event_list = eventsRes.data.event_list;
                    this.leave_list = eventsRes.data.leave_list;
                } else {
                    this.showSnackbar("red", eventsRes.data.snackbar);
                    sessionStorage.setItem("error-trace", eventsRes.data.error_trace);
                }

                // Instructor Sessions
                if (sessionRes.data.flag === "YES") {
                    this.tt_list = sessionRes.data.tt_list;
                } else {
                    this.showSnackbar("red", sessionRes.data.snackbar);
                    sessionStorage.setItem("error-trace", sessionRes.data.error_trace);
                }

                // Instructor Birthdays
                if (birthdayRes.data.flag === "YES") {
                    this.bday_list = birthdayRes.data.bday_list;
                    this.bday_list_student = birthdayRes.data.bday_list_student;
                } else {
                    this.showSnackbar("red", birthdayRes.data.snackbar);
                    sessionStorage.setItem("error-trace", birthdayRes.data.error_trace);
                }

                // Instructor Training
                if (trainingRes.data.flag === "YES") {
                    this.training_details = trainingRes.data.training_details;
                    this.training_ay = trainingRes.data.training_ay;
                } else {
                    this.showSnackbar("red", trainingRes.data.snackbar);
                    sessionStorage.setItem("error-trace", trainingRes.data.error_trace);
                }

                // Sidebar Data
                this.items = sidebarRes.data.links;
                this.module_link = sidebarRes.data.to_show_module_management;
                this.search_links = sidebarRes.data.search_links;
                this.erp_easycheck_flag = sidebarRes.data.erp_easycheck_flag;
                this.erp_lib_flag = sidebarRes.data.erp_lib_flag;
                this.show_parent_uid = sidebarRes.data.show_parent_uid;
                this.parent_uid = sidebarRes.data.parent_uid;
                this.show_addmission_form = true;
                this.quick_links = sidebarRes.data.quick_links;
                if (sidebarRes.data.erp_easycheck_flag === "YES") {
                    this.uid = sidebarRes.data.uid;
                    this.easycheck_url = sidebarRes.data.url;
                    this.erp_url = sidebarRes.data.erp_url;
                    this.hash_key = sidebarRes.data.key;
                    this.flag = true;
                }
                if (sidebarRes.data.erp_lib_flag === "YES") {
                    this.uid = sidebarRes.data.uid;
                    this.prn = sidebarRes.data.prn;
                    this.random_key = sidebarRes.data.random;
                    this.lib_url = sidebarRes.data.url;
                    this.erp_url = sidebarRes.data.erp_url;
                    this.hash_key = sidebarRes.data.key;
                    this.org_code = sidebarRes.data.org_code;
                    this.flag = true;
                }
            } catch (error) {
                console.log(error);
                this.$router.push("/");
            } finally {
                this.isLoading = false;
            }
        },
        getCalandar() {
            this.$store.commit("setcalendar_flag", this.$store.state.calendar_flag);
            this.events = new Date();
            axios
                .get("/communication/getInstructorDateData")
                .then((res) => {
                    if (res.data.msg === "200") {
                        if (res.data.inst_data.length) {
                            this.events = res.data.inst_data;
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.todayBirthday();
        this.awspath = localStorage.getItem("awspath");
        this.user_type = localStorage.getItem("EPS-ut");
        this.tenant = localStorage.getItem("EPS-tenant");
        this.fetchData();
        if (this.user_type === "Employee") {
            this.getCalandar();
        }
    },
    created() {
        this.user_type = localStorage.getItem("EPS-ut");
        this.tenant = localStorage.getItem("EPS-tenant");
        this.isDrawer = sessionStorage.getItem("isDrawer") === null ? !this.$vuetify.breakpoint.xs : sessionStorage.getItem("isDrawer") === "true";
    },
};
</script>

<style scoped>
.card {
    margin: 8px;
    height: 100%;
    border-radius: 20px !important;
    /* color: orange; */
    /* background-color: #D3D3D3; */
    /* background-color: #f4a688; */
    /* color: #674d3c; */
    background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%);
    color: rgb(128 2 112);
}

router-link:hover {
    color: red;
}

.card:hover {
    background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);

    color: rgb(128 2 112) !important;
    font-weight: bold !important;
    text-align: center;
    box-shadow: 20px 20px 20px grey !important;
    -webkit-transition: box-shadow 0.3s ease-in !important;
}

.v-avatar.elevated-avatar {
    border: 2px solid #5c6bc0;
    background: linear-gradient(to right, #9575cd, #7986cb);
    color: white;
}

v-card {
    border-radius: 22px;
}

@media (max-width: 920px) {

    body {
        overflow-x: hidden;
        width: 100%;
    }
}

.button {
    border: 2px solid white !important;
    color: #0f2027;
    /* background: transparent !important; */
    border-radius: 50px !important;
    margin: 0.5rem !important;
    background-color: white !important;
}

.button:hover {
    color: white !important;
    background: #ffc200 !important;
}

.animated-dialog {
    background: linear-gradient(135deg, #ffe0ec, #ffffff);
    border-radius: 16px;
    box-shadow: 0 12px 24px rgba(255, 105, 180, 0.3);
    overflow: hidden;
}

.dialog-text-animate {
    animation: fade-slide-in 1s ease forwards;
}

@keyframes fade-slide-in {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
